import { render, staticRenderFns } from "./PortfolioUploadSection.vue?vue&type=template&id=b071cab4&scoped=true&"
import script from "./PortfolioUploadSection.vue?vue&type=script&lang=js&"
export * from "./PortfolioUploadSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b071cab4",
  null
  
)

export default component.exports